<div class="row">
  <div class="col-12 mb-4">
    <div class="d-flex gap-10 align-items-center">
      <app-text-avatar [text]="currentUser.name"></app-text-avatar>

      <app-text-editor
        [formControl]="commentControl"
        [showToolbar]="mode() === EItemCommentGeneratorMode.extended"
        [noDataPlaceholder]="'field.commentPlaceholder' | translate"
        [isAppearanceOutline]="true"
        (focused)="changeMode(EItemCommentGeneratorMode.extended)"
        (focusedOut)="changeMode(EItemCommentGeneratorMode.minimized)"
      ></app-text-editor>
    </div>
    <div *ngIf="mode() === EItemCommentGeneratorMode.extended" class="text-right pt-2">
      <button (click)="changeMode(EItemCommentGeneratorMode.minimized)" class="me-2" matButton="tonal">
        {{ 'button.cancel' | translate }}
      </button>
      <button mat-flat-button type="submit" (click)="onSubmitComment()">
        {{ 'button.addContext' | translate: { context: 'field.comment' | translate } }}
      </button>
    </div>
  </div>

  <div *ngFor="let comment of store.comments()" class="col-lg-12 comment-item">
    <app-comment-card
      [comment]="comment"
      (editComment)="editComment($event, comment.id)"
      (deleteComment)="deleteComment($event)"
      (isEditing)="isEditing($event)"
      [closeEditMode]="isEditingId !== undefined && isEditingId !== comment.id"
    ></app-comment-card>
  </div>
</div>
